import './style.css';
const President = () =>{
    return(
    <div className='pre_container'>
        <div className="pre">
        <div className="pre_image">
            <img src ='/images/우미경.jpeg' alt="우미경" />
        </div>
        <div className="pre_text">
            <h4>"하모니카로 모두가 함께 즐기며 소통하는 아름다운 세상"</h4>
            <div>
            21세기의 화두는 문화입니다. 그리고 음악은 세계 공통언어입니다. 
            <br/><br/>
            음악은 전공자들만 즐기는 전유물이 아닌 누구나가 즐거움을 공유하고 아름다움을 표현할 수 있는 자기표현의 수단입니다. <br/><br/>
            한국하모니카교육협회는 하모니카로 모두가 함께 즐기며 소통하는 아름다운 세상을 만들기 위해 문을 열었습니다. <br/><br/>
            그동안 본회는 어떤 악기보다 쉽고 재미있게 익힐 수 있는 하모니카가 많은 사람들이 공유할 수 있도록 각 기관, 단체, 정부 등과 협력하여 생활 악기로 자리매김하도록 노력하고 있습니다.<br/><br/>
            앞으로도 한국하모니카교육협회는 하모니카를 사랑하는 모든 분들이 언제나 행복을 느낄 수 있는 공간으로 만들어 가겠습니다.<br/>
            </div>
        </div>
        </div>
        <div className='pre_name'>
            <h4>하모니카교육협회 회장 우미경</h4>
            <label>코리아하모니카오케스트라 단장 /<br/>서울국제하모니카페스티벌 조직위원장</label>
        </div>
    </div>
    )

}
export default President;